module.exports = __webpack_public_path__ + "img/kh.ffda5c6.svg";